import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import { colorsPalette } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'flex',
      background: theme.palette.secondary.main,
      borderRadius: 50,
      width: 'fit-content',
      marginLeft: 'auto',
      marginBottom: 24,
      overflow: 'hidden',
    },
    roleBtn: {
      color: fade(colorsPalette.white, 0.33),
      fontWeight: 700,
      padding: '14px 24px',
      transition: 'all .3s',
      '&.active': {
        background: colorsPalette.violetAnalyticsCard,
        color: colorsPalette.white,
      },
    },
  }),
);

export default useStyles;
